import { render } from "./Head.vue?vue&type=template&id=ff583ae6&scoped=true"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"

import "./Head.vue?vue&type=style&index=0&id=ff583ae6&scoped=true&lang=css"

import exportComponent from "E:\\软件项目\\深圳官网\\official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff583ae6"]])

export default __exports__